import moment from 'moment'

export const ISO_FORMAT = 'YYYY-MM-DD'
export function isoDate(date = moment()) {
  return moment(date).format(ISO_FORMAT)
}